import React from 'react';
import { C, DISP, BODY, FadeUp, Kicker, SectionH2, SectionSub, SECTION_PAD, useSectionView } from './shared';
import { ProductWalkthrough } from './ProductWalkthrough';

const STEPS = [
  { n: '1', title: 'It learns your business', body: 'From your website, brand settings and what you tell it: voice, products, audience, goals.' },
  { n: '2', title: 'It recommends the highest-impact action', body: 'Not a list of everything you could do. The one thing worth doing next, with the reason why.' },
  { n: '3', title: 'You approve or adjust', body: 'You stay in charge. Change the angle, the channel or the goal in one step.' },
  { n: '4', title: 'It creates the campaign assets', body: 'Posts, emails, ads, visuals and landing pages. Everything the plan calls for, in your voice.' },
  { n: '5', title: 'You schedule, publish or export', body: 'Send it to your calendar, download it, or publish a landing page directly.' },
  { n: '6', title: 'It learns from what you did', body: 'Completed campaigns feed the strategic memory, so the next recommendation is sharper.' },
];

export const HowItWorksSection = () => {
  const ref = useSectionView('how_it_works');
  return (
    <section id="how-it-works" ref={ref} style={{ padding: SECTION_PAD, background: 'rgba(255,255,255,0.012)' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <FadeUp><Kicker>How it works</Kicker></FadeUp>
        <FadeUp delay={80}>
          <SectionH2>
            From &ldquo;what should I do?&rdquo;<br />
            <span style={{ color: C.lime }}>to campaign launched.</span>
          </SectionH2>
        </FadeUp>
        <FadeUp delay={140}>
          <SectionSub>
            ScalitOS is not a blank chat box waiting for the right question. It runs a loop, and the loop runs your marketing.
          </SectionSub>
        </FadeUp>

        <div style={{ marginTop: 56, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(300px, 100%), 1fr))', gap: 16 }}>
          {STEPS.map((s, i) => (
            <FadeUp key={i} delay={i * 70}>
              <div className="scl-card" style={{ display: 'flex', gap: 16, padding: '24px 22px', border: `1px solid ${C.border}`, borderRadius: 14, background: C.surface, height: '100%' }}>
                <span style={{ width: 34, height: 34, flexShrink: 0, borderRadius: 10, border: `1px solid ${C.borderLime}`, background: 'rgba(200,241,53,0.06)', display: 'grid', placeItems: 'center', fontFamily: DISP, fontWeight: 800, fontSize: 15, color: C.lime }}>{s.n}</span>
                <div>
                  <p style={{ fontFamily: DISP, fontWeight: 700, fontSize: 16, color: C.text, marginBottom: 8 }}>{s.title}</p>
                  <p style={{ fontFamily: BODY, fontSize: 14, lineHeight: 1.65, color: C.body }}>{s.body}</p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>

        <ProductWalkthrough />
      </div>
    </section>
  );
};
